import React from 'react';
import { TextInput } from '../../Form';
import { useFocusContext } from '../../../contexts/FocusContext';
import clsx from 'clsx';

export default function QuantityField({
  id,
  name,
  value,
  onChange,
  required = false,
  min = 0,
  max = 9999,
  onFocus,
  onBlur,
  className,
  fixedWidth = false,
  ...props
}) {
  const focusContext = useFocusContext();

  const handleFocus = e => {
    if (focusContext) {
      focusContext.setFocused(true, id);
    }
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = e => {
    if (focusContext) {
      focusContext.setFocused(false, null);
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <TextInput
      id={id}
      name={name}
      type="number"
      min={min}
      max={max}
      value={value}
      onChange={e => {
        // convert to number before passing to onChange
        const value = parseInt(e.target.value, 10);

        if (isNaN(value)) {
          onChange('');
          return;
        }

        onChange(value);
      }}
      onFocus={handleFocus}
      onBlur={handleBlur}
      required={required}
      // !w-auto is emitted after !w-12, so it wins and the box takes whatever its
      // row leaves; fixedWidth keeps it at 3rem so the rows line up.
      className={clsx(
        'cp_form-textinput cp_quantity-input mx-1 text-center !w-12',
        !fixedWidth && '!w-auto',
        className,
      )}
      {...props}
    />
  );
}
